import { useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { alpha } from '@mui/material/styles';
import { Box, Divider, Typography, MenuItem, Avatar, IconButton, Popover } from '@mui/material';
import { useUser } from '../../../hooks/UserContext';
import { useRole } from '../../../hooks/useRole';

function parseUser(user) {
  if (!user) return {};
  if (typeof user === 'object') return user;
  try { return JSON.parse(user); } catch { return {}; }
}

export default function AccountPopover() {
  const [open, setOpen] = useState(null);
  const { user, logout } = useUser();
  const { hasProjectAccess, hasIotAccess } = useRole();
  const userData = parseUser(user);

  const handleOpen = (event) => setOpen(event.currentTarget);
  const handleClose = () => setOpen(null);
  const handleLogout = () => { logout(); setOpen(null); };

  const showProjectLink = hasProjectAccess;
  const showSystemLink = hasIotAccess;
  const showNavLinks = showProjectLink || showSystemLink;

  return (
    <>
      <IconButton
        onClick={handleOpen}
        sx={{
          p: 0,
          ...(open && {
            '&:before': {
              zIndex: 1, content: "''", width: '100%', height: '100%',
              borderRadius: '50%', position: 'absolute',
              bgcolor: (theme) => alpha(theme.palette.grey[900], 0.8),
            },
          }),
        }}
      >
        <Avatar src={userData.profilePicture} alt="photoURL" />
      </IconButton>

      <Popover
        open={Boolean(open)}
        anchorEl={open}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        PaperProps={{
          sx: {
            p: 0, mt: 1.5, ml: 0.75, width: 200,
            '& .MuiMenuItem-root': { typography: 'body2', borderRadius: 0.75 },
          },
        }}
      >
        <Box sx={{ my: 1.5, px: 2.5 }}>
          <Typography variant="subtitle2" noWrap>
            {userData.displayName || userData.name || 'User'}
          </Typography>
          <Typography variant="body2" sx={{ color: 'text.secondary' }} noWrap>
            {userData.email || ''}
          </Typography>
        </Box>

        {showNavLinks && (
          <>
            <Divider sx={{ borderStyle: 'dashed' }} />
            <Box sx={{ p: 1 }}>
              {showProjectLink && (
                <MenuItem component={RouterLink} to="/project/home" onClick={handleClose}>
                  Project
                </MenuItem>
              )}
              {showSystemLink && (
                <MenuItem component={RouterLink} to="/admin/dashboard" onClick={handleClose}>
                  System
                </MenuItem>
              )}
              <MenuItem component={RouterLink} to="/measure/dashboard" onClick={handleClose}>
                Measure
              </MenuItem>
            </Box>
          </>
        )}

        <Divider sx={{ borderStyle: 'dashed' }} />

        <MenuItem onClick={handleLogout} sx={{ m: 1 }}>
          Logout
        </MenuItem>
      </Popover>
    </>
  );
}
